// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  body.print-mode {
    margin: 0;
    padding: 0;
    background-color: #fff;
    -webkit-print-color-adjust: exact; /* Chrome, Safari */
    color-adjust: exact; /* Firefox, Edge */
  }

  .printable-container-wrapper {
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
    background-color: #fff !important;
  }

  .printable-new-price-list {
    max-width: none !important; /* Override max-width for print */
    margin: 0 !important; /* Override margin for print */
    padding: 5mm !important; /* Add some minimal padding for print */
  }

  .printable-new-price-list .price-list-header,
  .printable-new-price-list .price-list-footer {
    text-align: center;
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f8f9fa; /* Light background for header/footer in print */
  }
  .printable-new-price-list .price-list-header h1 {
    font-size: 1.5em;
    margin-bottom: 5px;
    color: #333;
  }
  .printable-new-price-list .price-list-header h2 {
    font-size: 1.2em;
    margin-bottom: 10px;
    color: #555;
  }
  .printable-new-price-list .price-list-header p,
  .printable-new-price-list .price-list-footer p {
    font-size: 0.9em;
    color: #666;
    margin: 2px 0;
  }

  .print\\:break-after-page {
    page-break-after: always;
    break-after: page;
  }
  .print\\:break-inside-avoid-page {
    page-break-inside: avoid;
    break-inside: avoid-page;
  }
}

.printable-new-price-list {
  font-family: 'Arial', sans-serif;
  color: #333;
  padding: 20px; /* Padding for screen view */
  max-width: 1200px; /* Max width for screen view */
  margin: 0 auto; /* Center on screen */
}

.printable-new-price-list .price-list-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #eee;
  padding-bottom: 20px;
}

.printable-new-price-list .price-list-header h1 {
  font-size: 2em;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 0.25em;
}

.printable-new-price-list .price-list-header h2 {
  font-size: 1.5em;
  color: #34495e;
  margin-bottom: 0.5em;
}

.printable-new-price-list .price-list-header p {
  font-size: 1em;
  color: #7f8c8d;
}

.printable-new-price-list .structure-card {
  display: flex;
  flex-direction: column; /* Stack image and details vertically on small screens */
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 25px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  /* overflow: hidden; Ensures border-radius applies to children */
  page-break-inside: avoid; /* Try to keep card on one page */
  width: calc(100%); /* 50% width for two cards per row on larger screens */;
}

@media (min-width: 768px) { /* Apply side-by-side layout for medium screens and up */
  .printable-new-price-list .structure-card {
    flex-direction: row;
  }
}

.printable-new-price-list .card-image-section {
  flex: 1 1 40%; /* Takes up 40% of the width on larger screens */
  min-width: 280px; /* Minimum width for the image section */
  background-color: #f0f0f0; /* Placeholder background */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0; /* Separator for stacked layout */
}

@media (min-width: 768px) {
  .printable-new-price-list .card-image-section {
    border-bottom: none;
    border-right: 1px solid #e0e0e0; /* Separator for side-by-side layout */
  }
}

/* Styles for single image display */
.printable-new-price-list .image-gallery-placeholder.single-image-container figure {
  margin: 0;
  text-align: center;
}
.printable-new-price-list .image-gallery-placeholder .primary-image {
  max-width: 100%;
  max-height: 300px; /* Limit image height for single display */
  height: auto;
  border-radius: 6px;
  object-fit: cover;
  margin-bottom: 5px; /* Space for caption */
}

/* Styles for combined (multiple) images display */
.printable-new-price-list .image-gallery-placeholder.combined-images-container {
  display: flex;
  flex-wrap: wrap; /* Allow images to wrap */
  gap: 10px; /* Space between images */
  justify-content: center; /* Center images if they don't fill the row */
  align-items: flex-start; /* Align items at the top */
  max-height: 400px; /* Max height for the container */
  overflow-y: auto; /* Scroll if too many images */
}

.printable-new-price-list .combined-image-item {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.333% - 10px); /* Aim for 3 images per row, adjust as needed */
  max-width: calc(33.333% - 10px);
  min-width: 120px; /* Minimum width for smaller images */
  text-align: center;
}

.printable-new-price-list .combined-image-item figure {
  margin: 0;
}

.printable-new-price-list .combined-image-item .combined-image {
  width: 100%;
  height: auto;
  max-height: 120px; /* Smaller height for combined images */
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 4px; /* Space for caption */
}

.printable-new-price-list .image-caption {
  font-size: 0.75em;
  color: #555;
  text-align: center;
}


.printable-new-price-list .image-gallery-placeholder.no-image,
.printable-new-price-list .combined-image-item.no-image-item {
  text-align: center;
  color: #888;
  font-style: italic;
  padding: 20px;
  min-height: 150px; /* Ensure some height even without image */
  display: flex;
  align-items: center;
  justify-content: center;
}

.printable-new-price-list .more-images-note { /* This class might be unused now but kept for safety */
  font-size: 0.8em;
  color: #777;
  text-align: center;
  margin-top: 8px;
}

.printable-new-price-list .card-details-section {
  flex: 1 1 60%; /* Takes up 60% of the width on larger screens */
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Distribute content within details section */
}

.printable-new-price-list .card-title {
  font-size: 1.6em;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.printable-new-price-list .card-code {
  font-size: 0.9em;
  color: #777;
  margin-bottom: 15px;
}

.printable-new-price-list .card-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}

.printable-new-price-list .card-label {
  font-size: 0.85em;
  color: #555;
  font-weight: bold;
  margin-bottom: 3px;
}

.printable-new-price-list .card-value,
.printable-new-price-list .card-description,
.printable-new-price-list .address-list li {
  font-size: 0.95em;
  color: #444;
  line-height: 1.5;
}

.printable-new-price-list .card-description {
  margin-bottom: 15px;
  white-space: pre-wrap; /* Preserve line breaks in description */
}

.printable-new-price-list .combined-details-section {
  margin-bottom: 15px;
}

.printable-new-price-list .address-list,
.printable-new-price-list .description-list {
  list-style: none; /* Changed from disc to none for a cleaner look with codes */
  padding-left: 0; /* Remove default padding */
  max-height: 100px; /* Limit height for long lists */
  overflow-y: auto; /* Add scroll for long lists */
  font-size: 0.9em;
}
.printable-new-price-list .address-list li,
.printable-new-price-list .description-list li {
  margin-bottom: 4px; /* Increased spacing a bit */
  line-height: 1.4;
}

.printable-new-price-list .address-list li strong,
.printable-new-price-list .description-list li strong {
  font-weight: bold;
  margin-right: 5px;
  color: #333; /* Darker color for code */
}


.printable-new-price-list .card-pricing {
  margin-top: auto; /* Pushes pricing to the bottom */
  padding-top: 15px;
  border-top: 1px solid #eee;
  margin-bottom: 15px;
}

.printable-new-price-list .card-pricing p {
  font-size: 1.1em;
  margin: 5px 0;
  color: #333;
}

.printable-new-price-list .price-value {
  font-weight: bold;
  color: #007bff; /* Highlight price */
}

.printable-new-price-list .static-map-placeholder {
  margin-top: 15px;
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  text-align: center;
  font-size: 0.9em;
  color: #555;
  border-radius: 4px;
}

.printable-new-price-list .static-map-placeholder p {
  margin-bottom: 8px;
}

.printable-new-price-list .static-map-placeholder small {
  font-size: 0.8em;
  color: #777;
}

/* Removed .map-link styles as it's no longer used */
/*
.printable-new-price-list .map-link {
  font-size: 0.9em;
  color: #007bff;
  text-decoration: none;
  transition: color 0.2s;
}

.printable-new-price-list .map-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.printable-new-price-list .price-list-footer {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 2px solid #eee;
  font-size: 0.9em;
  color: #7f8c8d;
}

.printable-new-price-list .price-list-footer p {
  margin: 5px 0;
}

/* Ensure cards don't get too wide on very large screens if not using max-width on container */
@media (min-width: 1400px) {
  .printable-new-price-list .structure-card {
    /* max-width: 1000px; /* Optional: if you want to cap card width */
    /* margin-left: auto; */
    /* margin-right: auto; */
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/printable/PrintableNewPriceList.css"],"names":[],"mappings":"AAAA;EACE;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,iCAAiC,EAAE,mBAAmB;IACtD,mBAAmB,EAAE,kBAAkB;EACzC;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,0BAA0B,EAAE,iCAAiC;IAC7D,oBAAoB,EAAE,8BAA8B;IACpD,uBAAuB,EAAE,uCAAuC;EAClE;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,yBAAyB,EAAE,gDAAgD;EAC7E;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;EACA;;IAEE,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,wBAAiB;IAAjB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IAAxB,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,aAAa,EAAE,4BAA4B;EAC3C,iBAAiB,EAAE,8BAA8B;EACjD,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,wDAAwD;EAChF,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,gEAAgE;EAChE,wBAAwB,EAAE,iCAAiC;EAC3D,iBAAiB,EAAE,sDAAsD;AAC3E;;AAEA,4BAA4B,wDAAwD;EAClF;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa,EAAE,gDAAgD;EAC/D,gBAAgB,EAAE,wCAAwC;EAC1D,yBAAyB,EAAE,2BAA2B;EACtD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC,EAAE,iCAAiC;AACrE;;AAEA;EACE;IACE,mBAAmB;IACnB,+BAA+B,EAAE,sCAAsC;EACzE;AACF;;AAEA,oCAAoC;AACpC;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB,EAAE,0CAA0C;EAC7D,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,eAAe,EAAE,yBAAyB;EAC1C,SAAS,EAAE,yBAAyB;EACpC,uBAAuB,EAAE,6CAA6C;EACtE,uBAAuB,EAAE,2BAA2B;EACpD,iBAAiB,EAAE,iCAAiC;EACpD,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;EACE,YAA8B;EAA9B,cAA8B;EAA9B,gCAA8B,EAAE,+CAA+C;EAC/E,+BAA+B;EAC/B,gBAAgB,EAAE,qCAAqC;EACvD,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,uCAAuC;EAC1D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;;AAGA;;EAEE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,iBAAiB,EAAE,0CAA0C;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,8CAA8C,uDAAuD;EACnG,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,gDAAgD;EAC/D,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAE,8CAA8C;AAChF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB,EAAE,wCAAwC;AACjE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB,EAAE,4DAA4D;EAC9E,eAAe,EAAE,2BAA2B;EAC5C,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB,EAAE,8BAA8B;EAChD,gBAAgB;AAClB;AACA;;EAEE,kBAAkB,EAAE,4BAA4B;EAChD,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW,EAAE,0BAA0B;AACzC;;;AAGA;EACE,gBAAgB,EAAE,iCAAiC;EACnD,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,oDAAoD;AACpD;;;;;;;;;;;;;;;;;;;;;;;;;;8FA0B8F;AAC9F;EACE;IACE,kEAAkE;IAClE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF","sourcesContent":["@media print {\n  body.print-mode {\n    margin: 0;\n    padding: 0;\n    background-color: #fff;\n    -webkit-print-color-adjust: exact; /* Chrome, Safari */\n    color-adjust: exact; /* Firefox, Edge */\n  }\n\n  .printable-container-wrapper {\n    margin: 0 !important;\n    padding: 0 !important;\n    box-shadow: none !important;\n    background-color: #fff !important;\n  }\n\n  .printable-new-price-list {\n    max-width: none !important; /* Override max-width for print */\n    margin: 0 !important; /* Override margin for print */\n    padding: 5mm !important; /* Add some minimal padding for print */\n  }\n\n  .printable-new-price-list .price-list-header,\n  .printable-new-price-list .price-list-footer {\n    text-align: center;\n    margin-bottom: 20px;\n    padding: 10px;\n    background-color: #f8f9fa; /* Light background for header/footer in print */\n  }\n  .printable-new-price-list .price-list-header h1 {\n    font-size: 1.5em;\n    margin-bottom: 5px;\n    color: #333;\n  }\n  .printable-new-price-list .price-list-header h2 {\n    font-size: 1.2em;\n    margin-bottom: 10px;\n    color: #555;\n  }\n  .printable-new-price-list .price-list-header p,\n  .printable-new-price-list .price-list-footer p {\n    font-size: 0.9em;\n    color: #666;\n    margin: 2px 0;\n  }\n\n  .print\\:break-after-page {\n    break-after: page;\n  }\n  .print\\:break-inside-avoid-page {\n    break-inside: avoid-page;\n  }\n}\n\n.printable-new-price-list {\n  font-family: 'Arial', sans-serif;\n  color: #333;\n  padding: 20px; /* Padding for screen view */\n  max-width: 1200px; /* Max width for screen view */\n  margin: 0 auto; /* Center on screen */\n}\n\n.printable-new-price-list .price-list-header {\n  text-align: center;\n  margin-bottom: 30px;\n  border-bottom: 2px solid #eee;\n  padding-bottom: 20px;\n}\n\n.printable-new-price-list .price-list-header h1 {\n  font-size: 2em;\n  font-weight: bold;\n  color: #2c3e50;\n  margin-bottom: 0.25em;\n}\n\n.printable-new-price-list .price-list-header h2 {\n  font-size: 1.5em;\n  color: #34495e;\n  margin-bottom: 0.5em;\n}\n\n.printable-new-price-list .price-list-header p {\n  font-size: 1em;\n  color: #7f8c8d;\n}\n\n.printable-new-price-list .structure-card {\n  display: flex;\n  flex-direction: column; /* Stack image and details vertically on small screens */\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  margin-bottom: 25px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);\n  /* overflow: hidden; Ensures border-radius applies to children */\n  page-break-inside: avoid; /* Try to keep card on one page */\n  width: calc(100%); /* 50% width for two cards per row on larger screens */;\n}\n\n@media (min-width: 768px) { /* Apply side-by-side layout for medium screens and up */\n  .printable-new-price-list .structure-card {\n    flex-direction: row;\n  }\n}\n\n.printable-new-price-list .card-image-section {\n  flex: 1 1 40%; /* Takes up 40% of the width on larger screens */\n  min-width: 280px; /* Minimum width for the image section */\n  background-color: #f0f0f0; /* Placeholder background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  border-bottom: 1px solid #e0e0e0; /* Separator for stacked layout */\n}\n\n@media (min-width: 768px) {\n  .printable-new-price-list .card-image-section {\n    border-bottom: none;\n    border-right: 1px solid #e0e0e0; /* Separator for side-by-side layout */\n  }\n}\n\n/* Styles for single image display */\n.printable-new-price-list .image-gallery-placeholder.single-image-container figure {\n  margin: 0;\n  text-align: center;\n}\n.printable-new-price-list .image-gallery-placeholder .primary-image {\n  max-width: 100%;\n  max-height: 300px; /* Limit image height for single display */\n  height: auto;\n  border-radius: 6px;\n  object-fit: cover;\n  margin-bottom: 5px; /* Space for caption */\n}\n\n/* Styles for combined (multiple) images display */\n.printable-new-price-list .image-gallery-placeholder.combined-images-container {\n  display: flex;\n  flex-wrap: wrap; /* Allow images to wrap */\n  gap: 10px; /* Space between images */\n  justify-content: center; /* Center images if they don't fill the row */\n  align-items: flex-start; /* Align items at the top */\n  max-height: 400px; /* Max height for the container */\n  overflow-y: auto; /* Scroll if too many images */\n}\n\n.printable-new-price-list .combined-image-item {\n  flex: 1 1 calc(33.333% - 10px); /* Aim for 3 images per row, adjust as needed */\n  max-width: calc(33.333% - 10px);\n  min-width: 120px; /* Minimum width for smaller images */\n  text-align: center;\n}\n\n.printable-new-price-list .combined-image-item figure {\n  margin: 0;\n}\n\n.printable-new-price-list .combined-image-item .combined-image {\n  width: 100%;\n  height: auto;\n  max-height: 120px; /* Smaller height for combined images */\n  object-fit: cover;\n  border-radius: 4px;\n  margin-bottom: 4px; /* Space for caption */\n}\n\n.printable-new-price-list .image-caption {\n  font-size: 0.75em;\n  color: #555;\n  text-align: center;\n}\n\n\n.printable-new-price-list .image-gallery-placeholder.no-image,\n.printable-new-price-list .combined-image-item.no-image-item {\n  text-align: center;\n  color: #888;\n  font-style: italic;\n  padding: 20px;\n  min-height: 150px; /* Ensure some height even without image */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.printable-new-price-list .more-images-note { /* This class might be unused now but kept for safety */\n  font-size: 0.8em;\n  color: #777;\n  text-align: center;\n  margin-top: 8px;\n}\n\n.printable-new-price-list .card-details-section {\n  flex: 1 1 60%; /* Takes up 60% of the width on larger screens */\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; /* Distribute content within details section */\n}\n\n.printable-new-price-list .card-title {\n  font-size: 1.6em;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.printable-new-price-list .card-code {\n  font-size: 0.9em;\n  color: #777;\n  margin-bottom: 15px;\n}\n\n.printable-new-price-list .card-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.printable-new-price-list .card-label {\n  font-size: 0.85em;\n  color: #555;\n  font-weight: bold;\n  margin-bottom: 3px;\n}\n\n.printable-new-price-list .card-value,\n.printable-new-price-list .card-description,\n.printable-new-price-list .address-list li {\n  font-size: 0.95em;\n  color: #444;\n  line-height: 1.5;\n}\n\n.printable-new-price-list .card-description {\n  margin-bottom: 15px;\n  white-space: pre-wrap; /* Preserve line breaks in description */\n}\n\n.printable-new-price-list .combined-details-section {\n  margin-bottom: 15px;\n}\n\n.printable-new-price-list .address-list,\n.printable-new-price-list .description-list {\n  list-style: none; /* Changed from disc to none for a cleaner look with codes */\n  padding-left: 0; /* Remove default padding */\n  max-height: 100px; /* Limit height for long lists */\n  overflow-y: auto; /* Add scroll for long lists */\n  font-size: 0.9em;\n}\n.printable-new-price-list .address-list li,\n.printable-new-price-list .description-list li {\n  margin-bottom: 4px; /* Increased spacing a bit */\n  line-height: 1.4;\n}\n\n.printable-new-price-list .address-list li strong,\n.printable-new-price-list .description-list li strong {\n  font-weight: bold;\n  margin-right: 5px;\n  color: #333; /* Darker color for code */\n}\n\n\n.printable-new-price-list .card-pricing {\n  margin-top: auto; /* Pushes pricing to the bottom */\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n  margin-bottom: 15px;\n}\n\n.printable-new-price-list .card-pricing p {\n  font-size: 1.1em;\n  margin: 5px 0;\n  color: #333;\n}\n\n.printable-new-price-list .price-value {\n  font-weight: bold;\n  color: #007bff; /* Highlight price */\n}\n\n.printable-new-price-list .static-map-placeholder {\n  margin-top: 15px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  background-color: #f9f9f9;\n  text-align: center;\n  font-size: 0.9em;\n  color: #555;\n  border-radius: 4px;\n}\n\n.printable-new-price-list .static-map-placeholder p {\n  margin-bottom: 8px;\n}\n\n.printable-new-price-list .static-map-placeholder small {\n  font-size: 0.8em;\n  color: #777;\n}\n\n/* Removed .map-link styles as it's no longer used */\n/*\n.printable-new-price-list .map-link {\n  font-size: 0.9em;\n  color: #007bff;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.printable-new-price-list .map-link:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n.printable-new-price-list .price-list-footer {\n  text-align: center;\n  margin-top: 40px;\n  padding-top: 20px;\n  border-top: 2px solid #eee;\n  font-size: 0.9em;\n  color: #7f8c8d;\n}\n\n.printable-new-price-list .price-list-footer p {\n  margin: 5px 0;\n}\n\n/* Ensure cards don't get too wide on very large screens if not using max-width on container */\n@media (min-width: 1400px) {\n  .printable-new-price-list .structure-card {\n    /* max-width: 1000px; /* Optional: if you want to cap card width */\n    /* margin-left: auto; */\n    /* margin-right: auto; */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
